import { lazyLoadImage } from "../utils/utils";

export default class Observer {
	constructor() {
		this.config = {
			rootMargin: "0px 0px 50px 0px",
			threshold: 0,
		};

		this.observer = new IntersectionObserver((entries, self) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (entry.target.tagName === "IMG") {
						// lazyLoadImage(entry.target);
						self.unobserve(entry.target);
					} else {
						entry.target.classList.add("loaded");
						entry.target.classList.add("visible");
					}
				}
			});
		}, this.config);

		this.images = document.querySelectorAll(
			'[data-src], [data-background], [loading="lazy"]'
		);
		this.images.forEach((image) => {
			this.observer.observe(image);
		});

		this.animateElements = document.querySelectorAll(".animate-in");
		this.animateElements.forEach((section) => {
			this.observer.observe(section);
		});


		
		this.config2 = {
			rootMargin: "0px 0px 50px 0px",
			threshold: 0,
		};
		this.observer2 = new IntersectionObserver((entries, self) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					document.body.classList.add('nav--light');
				} else {
					document.body.classList.remove('nav--light');
				}
			});
		}, this.config2);

		this.navTracking = document.querySelectorAll("body.light-mode [data-nav-watch]");
		this.navTracking.forEach((section) => {
			this.observer2.observe(section);
		});
	}
}
